// Module
var code = "<p>You may lose your eligibility for SCRA if you consolidate your student loans.</p> ";
// Exports
export default code;